import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { IFormPartners } from 'legacy/lut/classes/models/IFormPartners'
import { checkNewPartner } from 'legacy/lut/classes/services/PartnerDataStoreService'
import { useEffect, useState } from 'react'

import { CrudStore } from 'core/types/crudStore'

export const getNewPartnersSource = () =>
  CrudStore.get(CrudStoreItem.NewPartners, 'RequestDetail-newpartnersfetch')
export const getPartnersSource = () =>
  CrudStore.get(CrudStoreItem.PartnerAllData, 'RequestDetail-partnersfetch')

export const getSource = (partnerId: string) => {
  if (checkNewPartner(partnerId)) {
    return getNewPartnersSource()
  }
  return getPartnersSource()
}

export const getPartner = async (partnerId: string | undefined) => {
  if (partnerId) {
    const partnerSource = getSource(partnerId)

    return partnerSource.getById({ id: partnerId, force: true, keyField: 'PartnerID' })
  }
  return {}
}

export const usePartnerData = (partnerId: string | undefined) => {
  const [partner, setPartner] = useState<IFormPartners>({} as IFormPartners)
  const [partnerWip, setPartnerWipWip] = useState(false)
  const source = getSource(partnerId || '')

  useEffect(() => {
    const fetch = async () => {
      setPartnerWipWip(true)
      const res = await getPartner(partnerId)
      if (res) {
        setPartner(res)
      }
      setPartnerWipWip(false)
    }

    fetch()
  }, [partnerId, source])

  return { partner, partnerWip }
}
